import CustomViewSettings from "../../settings";


export default class CustomView_Glist_Settings extends CustomViewSettings {

    public customEntityId : string
    public dataUrl : string
    public glistSettings : any

    constructor(data:any) {
        super(data)

        if (!data) data = {}

        this.customEntityId = data.customEntityId
        this.glistSettings  = data.glistSettings
        this.dataUrl        = data.dataUrl

    }

}